import { render, staticRenderFns } from "./SettingTabs.vue?vue&type=template&id=227867d5&"
import script from "./SettingTabs.vue?vue&type=script&lang=js&"
export * from "./SettingTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports